import { Music, Clock, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { EVENTS, IMAGES } from '../data/content';
import { PageHero } from '../components/PageHero';
import { Reveal } from '../components/Reveal';
import { SerapeUnderline } from '../components/Serape';

const LiveMusicPage = () => {
  return (
    <div data-testid="live-music-page" className="bg-brand-night">
      <PageHero
        testid="music-hero"
        overline="En el Escenario"
        title="Bandas Mexicanas en Vivo"
        subtitle="Mariachi, banda, norteño y bolero — el sonido de México vive aquí varias noches a la semana. Sin cover, solo salud."
        image={IMAGES.mariachi}
      />

      <div className="mx-auto max-w-5xl px-6 md:px-12 py-20 md:py-28">
        <Reveal>
          <div className="flex items-center gap-3 mb-3">
            <Music className="text-brand-gold" size={24} />
            <h2 className="font-display font-bold text-2xl sm:text-3xl tracking-tight text-brand-cream">Próximas Presentaciones</h2>
          </div>
          <SerapeUnderline className="mb-10" />
        </Reveal>

        <div className="divide-y divide-brand-line border-y border-brand-line">
          {EVENTS.map((e, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div data-testid={`event-row-${i}`} className="group flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8 py-7 hover:bg-brand-coal transition-colors px-2 -mx-2">
                <div className="flex items-center gap-5 sm:w-48 shrink-0">
                  <div className="text-center bg-brand-coal border border-brand-line px-3 py-2 group-hover:border-brand-gold transition-colors">
                    <p className="font-display font-black text-2xl text-brand-gold leading-none">{e.date.split(' ')[1]}</p>
                    <p className="text-xs uppercase tracking-widest text-brand-muted">{e.date.split(' ')[0]}</p>
                  </div>
                  <span className="text-sm text-brand-cream/60">{e.day}</span>
                </div>
                <div className="flex-1">
                  <h3 className="font-display font-semibold text-xl sm:text-2xl text-brand-cream group-hover:text-brand-gold transition-colors">{e.band}</h3>
                  <p className="mt-1 flex items-center gap-2 text-sm text-brand-cream/60"><Clock size={14} />{e.genre}</p>
                </div>
                <span className="text-xs uppercase tracking-widest text-brand-agave font-medium">Entrada Libre</span>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Booking CTA */}
        <Reveal>
          <div className="relative mt-20 grid md:grid-cols-2 gap-8 items-center bg-brand-coal border border-brand-line p-10 md:p-14 overflow-hidden">
            <div className="pattern-dots-warm absolute inset-0 opacity-50" aria-hidden="true" />
            <div className="relative">
              <p className="uppercase text-xs tracking-[0.3em] text-brand-gold font-semibold mb-4">Músicos</p>
              <h3 className="font-display font-bold text-2xl sm:text-3xl tracking-tight text-brand-cream">¿Quieres tocar en nuestro escenario?</h3>
              <p className="mt-4 text-brand-cream/70">
                Siempre buscamos mariachi, banda y tríos para mantener viva la fiesta. Escríbenos y platiquemos.
              </p>
            </div>
            <div className="relative md:text-right">
              <Link to="/contact" data-testid="music-booking-cta" className="inline-flex items-center gap-2 bg-brand-gold text-brand-night px-7 py-4 text-sm uppercase tracking-widest font-semibold hover:bg-brand-citrus transition-colors">
                Contáctanos <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default LiveMusicPage;
